const Globe = ({ size = 24, color = "currentColor", ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="12" cy="12" r="9" stroke={color} strokeWidth="2" />
    <ellipse cx="12" cy="12" rx="5" ry="9" stroke={color} strokeWidth="1.5" />
    <path d="M12 3L12 21" stroke={color} strokeWidth="1.5" />
    <path d="M3 12H21" stroke={color} strokeWidth="1.5" />
    <path d="M5.5 7.5H18.5" stroke={color} strokeWidth="1.5" />
    <path d="M5.5 16.5H18.5" stroke={color} strokeWidth="1.5" />
  </svg>
);

export default Globe;
